"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLEAR_REGION_TIMEOUT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AnnouncerContext = _interopRequireDefault(require("./AnnouncerContext"));

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var ANNOUNCE_TIMEOUT = 1000;
var CLEAR_REGION_TIMEOUT = 2000;
exports.CLEAR_REGION_TIMEOUT = CLEAR_REGION_TIMEOUT;

var LiveRegion = function LiveRegion(_ref) {
  var ariaLive = _ref['aria-live'],
      role = _ref.role,
      children = _ref.children;

  var _useContext = (0, _react.useContext)(_AnnouncerContext.default),
      announceAssertive = _useContext.announceAssertive,
      announcePolite = _useContext.announcePolite;

  (0, _react.useEffect)(function () {
    if (ariaLive === 'polite') {
      setTimeout(function () {
        announcePolite({
          region: children,
          role: role
        });
      }, ANNOUNCE_TIMEOUT);
      setTimeout(function () {
        announcePolite({
          region: '',
          role: role
        });
      }, CLEAR_REGION_TIMEOUT);
    }

    if (ariaLive === 'assertive') {
      setTimeout(function () {
        announceAssertive({
          region: children,
          role: role
        });
      }, ANNOUNCE_TIMEOUT);
      setTimeout(function () {
        announceAssertive({
          region: '',
          role: role
        });
      }, CLEAR_REGION_TIMEOUT);
    } // Specify how to clean up aria regions.


    return function cleanup() {
      Object.values(_interfaces.LiveRegionRole).map(function (role) {
        announcePolite({
          region: '',
          role: role
        });
        announceAssertive({
          region: '',
          role: role
        });
        return null;
      });
    };
  }, [children]);
  return (0, _core.jsx)(_react.default.Fragment, null, children);
};

var _default = LiveRegion;
exports.default = _default;